import { Component, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { empty, from } from 'rxjs';
import { BetSlipProceedModalComponent } from '../../modals/bet-slip-proceed-modal/bet-slip-proceed-modal.component';
import { BetSelectionComponent } from '../../modals/bet-selection/bet-selection.component';
import { TranslateService } from '@ngx-translate/core';
import { NavParams } from '@ionic/angular';
import { CommonServiceService } from '../../services/common_service/common-service.service';
import { BettingServiceService } from '../../services/betting_service/betting-service.service';
import { StmgService } from "../../services/state_Management/stmg.service";
import { AlertController } from '@ionic/angular';
import { AlertComponent } from '../../components/alert/alert.component';

import { LoadingController } from '@ionic/angular';
import { RaceDetailsComponent } from '../../components/betting/race-details/race-details.component';
import { UserServiceService } from '../../services/user_service/user-service.service';
import { StorageServicesService } from '../../services/storage_services/storage-services.service';
import { UserInfo } from '../../services/payload/userInfo_pobj';



@Component({
  selector: 'app-bet-slip-modal',
  templateUrl: './bet-slip-modal.component.html',
  styleUrls: ['./bet-slip-modal.component.scss'],
})
export class BetSlipModalComponent implements OnInit {

  public selectionData = this.navParams.get('data');
  public bets = this.navParams.get('bets');
  token: any;
  doubleCount = 0;
  trebleCount = 0;
  alertTitle_Sucess: string;
  alertTitle_Error: string;
  alertDesc1: string;
  alertDesc2: string;
  Proceed_clicked: boolean;
  userInfo: UserInfo;
  betSlipToken1: any;

  hide_placeInput: boolean = false;
  hide_winInput: boolean = false;
  hide_placeInput_mOptions: boolean = false;
  hide_placeInput_keno: boolean = false;
  hide_placeInput_mOptions_keno: boolean = false;
  showMultipleOptions_single: boolean;
  showMultipleOptions_double: boolean;

  constructor(
    public modalController: ModalController,
    private stmgService: StmgService,
    public alertController: AlertController,
    private loadingController: LoadingController,
    private commonservice: CommonServiceService,
    private bettingService: BettingServiceService,
    public translate: TranslateService,
    private navParams: NavParams,
    private userService: UserServiceService,
    private storageService: StorageServicesService,
  ) { }

  ngOnInit() {

    // console.log("selections ", this.selectionData)
    this.Proceed_clicked = false;

    // <-----------KIRON GAMES------------>
    if (this.selectionData.root) {

      this.selectionData = {
        account: this.selectionData.account,
        bettingOptions: this.selectionData.root.bettingOptions,
        eventSelections: this.selectionData.root.eventSelections
      }

    } else {

      this.selectionData = this.selectionData;

    }

    // console.log(this.selectionData);


    //check how many DOUBLE options
    if (this.selectionData?.bettingOptions) {
      this.selectionData.bettingOptions.forEach(element => {
        if (element.betName == "DOUBLE") {
          this.doubleCount++;
        }
      });
    }

    //check how many TREBLE options
    if (this.selectionData?.bettingOptions) {
      this.selectionData.bettingOptions.forEach(element => {
        if (element.betName == "TREBLE") {
          this.trebleCount++;
        }
      });
    }
    //console.log(this.trebleCount);

    this.token = this.commonservice.getToken();

    this.stmgService.userInfoObervable.subscribe(userInfo =>
      this.userInfo = userInfo
    )


    this.showMultipleOptions();

  }




  remove_item(index) {
    
    if(this.bets.payload){

      this.total = 0;
      const removedItem = this.bets.payload.eventSelections[index];
      this.stmgService.updateSelections(removedItem);
      if(this.bets?.payload['@rule'] == "FeedId87BettingOptions" || this.bets?.payload['@rule'] == "FeedId88BettingOptions"){
        this.bets.payload.eventSelections.splice(index, 1);
      }
      this.stmgService.updateSelecteBets(this.bets);
      this.token = this.commonservice.getToken();

      if(this.bets.payload.eventSelections.length == 0){
        this.dismiss();
        return;
      }

      this.bettingService.getEventSelectionforBetPlace_mdm(this.bets, this.token).subscribe((data:any) => {

        this.selectionData = {
          account: data.account,
          bettingOptions: data.root.bettingOptions,
          eventSelections: data.root.eventSelections
        }

        this.doubleCount = 0;
        this.trebleCount = 0;
        this.selectionData.bettingOptions.forEach(element => {
          if (element.betName == "DOUBLE") {
            this.doubleCount++;
          }
        });

        this.selectionData.bettingOptions.forEach(element => {
          if (element.betName == "TREBLE") {
            this.trebleCount++;
          }
        });
      }, (error) => {
      });
    }else{
      //refresh race detail page when remove all from bet slip modal
      this.commonservice.sendClickEvent();
      this.total = 0;
      this.bets.eventSelections.splice(index, 1);
      this.stmgService.updateSelecteBets(this.bets);
      this.token = this.commonservice.getToken();

      this.bettingService.getEventSelectionforBetPlace(this.bets, this.token).subscribe(data => {
        this.selectionData = data;

        this.doubleCount = 0;
        this.trebleCount = 0;
        this.selectionData.bettingOptions.forEach(element => {
          if (element.betName == "DOUBLE") {
            this.doubleCount++;
          }
        });

        this.selectionData.bettingOptions.forEach(element => {
          if (element.betName == "TREBLE") {
            this.trebleCount++;
          }
        });

      }, (error) => {
      });
    }

  }

  remove_numbers() {

      this.total = 0;

      if(this.bets?.payload?.['@rule'] == "FeedId87BettingOptions"){

        const removedItems = this.bets.payload.eventSelections.filter(
          (selection:any) => Number(selection.selectionNumber) <= 24
        );

        this.stmgService.updateSelections(removedItems);

        this.bets.payload.eventSelections = this.bets.payload.eventSelections.filter(
          selection => Number(selection.selectionNumber) > 24
        );

      }else if(this.bets?.payload?.['@rule'] == "FeedId86BettingOptions"){

        const removedItems = this.bets.payload.eventSelections.filter(
          (selection:any) => Number(selection.selectionNumber) <= 80
        );

        this.stmgService.updateSelections(removedItems);

        this.bets.payload.eventSelections = this.bets.payload.eventSelections.filter(
          selection => Number(selection.selectionNumber) > 80
        );

      }

      
      this.stmgService.updateSelecteBets(this.bets);
      this.token = this.commonservice.getToken();

      if(this.bets.payload.eventSelections.length == 0){
        this.dismiss();
        return;
      }

      this.bettingService.getEventSelectionforBetPlace_mdm(this.bets, this.token).subscribe((data:any) => {

        this.selectionData = {
          account: data.account,
          bettingOptions: data.root.bettingOptions,
          eventSelections: data.root.eventSelections
        }
      }, (error) => {
      });

  }

  hasNumberSelectionsKeno(): boolean {
    if(this.bets?.payload?.['@rule'] == "FeedId86BettingOptions"){
      return this.selectionData?.eventSelections?.some(
        item => Number(item.selectionNumber) <= 80
      );
    }else{return false}
    
  }

  hasNumberSelectionsLL(): boolean {
    if(this.bets?.payload?.['@rule'] == "FeedId87BettingOptions"){
      return this.selectionData?.eventSelections?.some(
        item => Number(item.selectionNumber) <= 24
      );
    }else {
      return false;
    }
    
  }

  remove_all() {
    //refresh race detail page when remove all from bet slip modal
    this.dismiss();
    this.commonservice.sendClickEvent();
    this.total = 0;
    const empty_array = {
      eventSelections: []
    };
    this.selectionData;
    this.bets.eventSelections = empty_array;
    this.stmgService.updateSelecteBets(empty_array);
    this.selectionData.eventSelections = [];
    this.selectionData.bettingOptions = [];
    //console.log(this.bets);


  }

  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      'dismissed': true
    });
  }

  async openBetSlipProceedModal() {
    const modal = await this.modalController.create({
      component: BetSlipProceedModalComponent,
      cssClass: 'customPopup'
    });
    return await modal.present();
  }

  async open_bet_selection(item) {
    const modal = await this.modalController.create({
      component: BetSelectionComponent,
      cssClass: 'customPopup',
      componentProps: { item: item }
    });
    return await modal.present();
  }

  //create the DOUBLE search button data object
  async doubleOpenbetselection() {
    let arry = []
    this.selectionData.bettingOptions.forEach(element => {
      if (element.betName == "DOUBLE") {
        element.bets.forEach(ele => {
          arry.push(ele);
        });

      }
    });
    let object = {
      betName: "DOUBLE",
      betType: "2",
      multiplier: this.doubleCount,
      bets: arry
    }
    //console.log(object);
    const modal = await this.modalController.create({
      component: BetSelectionComponent,
      cssClass: 'customPopup',
      componentProps: { item: object }
    });
    return await modal.present();
  }


  //create the DOUBLE search button data object
  async trebleOpenbetselection() {
    let arry = []
    this.selectionData.bettingOptions.forEach(element => {
      if (element.betName == "TREBLE") {
        element.bets.forEach(ele => {
          arry.push(ele);
        });

      }
    });
    let object = {
      betName: "TREBLE",
      betType: "3",
      multiplier: this.trebleCount,
      bets: arry
    }
    //console.log(object);
    const modal = await this.modalController.create({
      component: BetSelectionComponent,
      cssClass: 'customPopup',
      componentProps: { item: object }
    });
    return await modal.present();
  }


  single = false;
  total = 0;
  selection_total = 0;
  input_changed(event) {
    this.total = 0;
    this.selection_total = 0;
    this.single = true;

    //disable the multiple option single input box
    if (this.selection_total == 0) {
      this.single = false;
    }

    // To check first one of the betting option is not single
    const firstOptionNotSingle = this.isGamesOption(this.selectionData.bettingOptions[0]?.betName);

    // if the first one of betting options is single go inside
    if(!firstOptionNotSingle){
      //if sigle input box filled then auto fill the other feilds
      if (this.selectionData.bettingOptions[0].win > 0) {
        for (let i = 0; i < this.selectionData.eventSelections.length; i++) {
          this.selectionData.eventSelections[i].win = this.selectionData.bettingOptions[0].win;
        }
      }

      //if sigle input box filled then auto fill the other feilds
      if (this.selectionData.bettingOptions[0].place > 0) {
        for (let i = 0; i < this.selectionData.eventSelections.length; i++) {
          this.selectionData.eventSelections[i].place = this.selectionData.bettingOptions[0].place;
        }
      }
    }

    

    //if object.win and .place "" set it to 0
    for (let i = 0; i < this.selectionData.eventSelections.length; i++) {
      if (this.selectionData.eventSelections[i].win == undefined) {
      } else {
        if (this.selectionData.eventSelections[i].win == "") {
          this.selectionData.eventSelections[i].win = 0;
        }
      }
      if (this.selectionData.eventSelections[i].place == undefined) {
      } else {
        if (this.selectionData.eventSelections[i].place == "") {
          this.selectionData.eventSelections[i].place = 0;
        }
      }
    }


    //if object.win and .place "" set it to 0
    for (let i = 0; i < this.selectionData.bettingOptions.length; i++) {
      if (this.selectionData.bettingOptions[i].win == undefined) {
      } else {
        if (this.selectionData.bettingOptions[i].win == "") {
          this.selectionData.bettingOptions[i].win = 0;
        }
      }
      if (this.selectionData.bettingOptions[i].place == undefined) {
      } else {
        if (this.selectionData.bettingOptions[i].place == "") {
          this.selectionData.bettingOptions[i].place = 0;
        }
      }
    }

    this.getTotal();


  }


  getTotal() {
    this.total = 0;
    //get the total of selection wins input boxes 
    for (let i = 0; i < this.selectionData.eventSelections.length; i++) {
      if (this.selectionData.eventSelections[i].win == undefined) {
      } else {
        this.total = this.total + Number(this.selectionData.eventSelections[i].win);
        this.selection_total = this.selection_total + Number(this.selectionData.eventSelections[i].win);
      }
    }

    //get the total of selection place input boxes 
    for (let i = 0; i < this.selectionData.eventSelections.length; i++) {
      if (this.selectionData.eventSelections[i].place == undefined) {
      } else {
        this.total = this.total + Number(this.selectionData.eventSelections[i].place);
        this.selection_total = this.selection_total + Number(this.selectionData.eventSelections[i].place);
      }
    }

    //get the total of mutiple optoin wins input boxes 
    for (let i = 0; i < this.selectionData.bettingOptions.length; i++) {
      // if (i == 0) { continue }
      // If the first one of betting options is not a "SINGLE" we didnt add the total to selections thats why added this
      if (i == 0) {
        const firstOptionNotSingle = this.isGamesOption(this.selectionData.bettingOptions[i]?.betName);
        if(!firstOptionNotSingle){
          continue
        }
      }
      if (this.selectionData.bettingOptions[i].win == undefined) {
      } else {
        this.total = this.total + Number(this.selectionData.bettingOptions[i].win) * this.selectionData.bettingOptions[i].multiplier;
      }
    }

    //get the total of mutiple optoin place input boxes
    for (let i = 0; i < this.selectionData.bettingOptions.length; i++) {
      // if (i == 0) { continue }
      // If the first one of betting options is not a "SINGLE" we didnt add the total to selections thats why added this
      if (i == 0) {
        const firstOptionNotSingle = this.isGamesOption(this.selectionData.bettingOptions[i]?.betName);
        if(!firstOptionNotSingle){
          continue
        }
      }
      if (this.selectionData.bettingOptions[i].place == undefined) {
      } else {
        this.total = this.total + Number(this.selectionData.bettingOptions[i].place) * this.selectionData.bettingOptions[i].multiplier;
      }
    }
  }



  click_proceed() {

    // genarate betSlipToken
    this.betSlipToken1 = new Date().valueOf();

    let betSlipToken = this.betSlipToken1.toString()

    // bind the betSlipToken token to selectionData
    if (betSlipToken != undefined || betSlipToken != null) {
      betSlipToken = betSlipToken;
    }



    if (this.total > 0) {

      this.presentLoading().then(() => {
        this.Proceed_clicked = true;
        this.bettingService.submitBet(this.selectionData, this.token, betSlipToken).subscribe(data => {
          //console.log(data);
          if (data['messageType'] == "ERROR") {

            //let alertTitle:string;
            this.translate.get('ALERTS.BET_ERR.TITLE').subscribe((res: string) => {
              this.alertTitle_Error = res;
            });
            let alert = new AlertComponent(this.alertController);
            alert.loginSuccessAlert("", this.alertTitle_Error, data['message']);
            this.loadingController.dismiss();

            this.Proceed_clicked = false;

          } else {
            // let alertTitle:string;

            this.translate.get('ALERTS.BET_SUCC.TITLE').subscribe((res: string) => {
              this.alertTitle_Sucess = res;
            });
            this.translate.get('ALERTS.BET_SUCC.DESC1').subscribe((res: string) => {
              this.alertDesc1 = res;
            });
            this.translate.get('ALERTS.BET_SUCC.DESC2').subscribe((res: string) => {
              this.alertDesc2 = res;
            });
            let alert = new AlertComponent(this.alertController);
            alert.loginSuccessAlert("", this.alertTitle_Sucess, this.alertDesc1 + " " + data['slip'].slipNo + "<br>" + this.alertDesc2 + " " + data['slip'].stakeAmount);
            this.loadingController.dismiss();
            this.remove_all();
            this.dismiss();

            // update user info
            this.updateUserInfoAfterBetPlaced();
          }

        }, (error) => {
          //this.dismiss();
          this.translate.get('ALERTS.BET_ERR.TITLE').subscribe((res: string) => {
            this.alertTitle_Error = res;
          });
          let alert = new AlertComponent(this.alertController);
          alert.loginSuccessAlert("", this.alertTitle_Error, "Please try again later");
          this.loadingController.dismiss();

          this.Proceed_clicked = false;

        });

      })

    } else {
      let alert = new AlertComponent(this.alertController);
      alert.loginSuccessAlert("", this.alertTitle_Error, "Please fill at least 1 bet");
    }



  }


  updateUserInfoAfterBetPlaced() {

    var accountNumber = JSON.parse(this.storageService.getLocal("accountNo"));
    var userInfoPayload = {
      account: accountNumber,
      token: this.token
    };


    if (accountNumber != null || accountNumber || undefined || accountNumber != "") {
      this.userService.getUserInfo(userInfoPayload).subscribe(data => {

      }, (error) => {

      });
    }


  }



  async presentLoading() {
    let alertTitle: string;
    this.translate.get('ALERTS.LOADING.TITLE').subscribe((res: string) => {
      alertTitle = res;
    });
    const loading = await this.loadingController.create({
      message: alertTitle,
      translucent: true,
    });
    return await loading.present();
  }


  doubleWinChanged(event) {
    //console.log(event.target.value);
    for (let i = 0; i < this.selectionData.bettingOptions.length; i++) {
      if (this.selectionData.bettingOptions[i].betName == "DOUBLE") {
        this.selectionData.bettingOptions[i].win = event.target.value;
      }
    }
    this.getTotal();
  }

  doublePlaceChanged(event) {
    //console.log(event.target.value);
    for (let i = 0; i < this.selectionData.bettingOptions.length; i++) {
      if (this.selectionData.bettingOptions[i].betName == "DOUBLE") {
        this.selectionData.bettingOptions[i].place = event.target.value;
      }
    }
    this.getTotal();
  }


  trebleWinChanged(event) {
    //console.log(event.target.value);
    for (let i = 0; i < this.selectionData.bettingOptions.length; i++) {
      if (this.selectionData.bettingOptions[i].betName == "TREBLE") {
        this.selectionData.bettingOptions[i].win = event.target.value;
      }
    }
    this.getTotal();
  }

  treblePlaceChanged(event) {
    //console.log(event.target.value);
    for (let i = 0; i < this.selectionData.bettingOptions.length; i++) {
      if (this.selectionData.bettingOptions[i].betName == "TREBLE") {
        this.selectionData.bettingOptions[i].place = event.target.value;
      }
    }
    this.getTotal();
  }

  // checkKr3Color(item) {
  //   console.log("colors", item);
  //   if (!item.isKLH) { return "noColor" }
  //   else {
  //     const colors = ['red', 'green', 'blue', 'yellow', 'black', 'purple', 'orange', 'white'];

  //     for (let i = 0; i < colors.length; i++) {
  //       const color = colors[i];
  //       if (item.name?.toLowerCase().includes(color)) {
  //         return color;
  //       }
  //     }

  //     return 'noColor';
  //   }
  // }

  checkKr3Color(item: any) {



    if (!item.isKLH && !item.countryCode) {
      return "noColor";
    }

    // KR8 special format: "1 (Red)" → extract (Red)
    if (item.countryCode === "KR8") {
      const clr = this.getColorName(item.name);
      return clr ? clr.toLowerCase() : "noColor";
    }

    if (item.countryCode === "KR6") {
      const num = Number(item.selectionNumber);

      if (num >= 1 && num <= 40) {
        return 'yellow';
      }
    
      if (num > 40 && num <= 80) {
        return 'red';
      }
    
      return '';
    }

    // Normal color detection
    const colors = ['red', 'green', 'blue', 'yellow', 'black', 'purple', 'orange', 'white'];
    for (let color of colors) {
      if (item.name?.toLowerCase().includes(color)) {
        return color;
      }
    }
    return "noColor";
  }
  getColorName(name: string): string {
    // Try to extract text inside parentheses
    const match = name.match(/\((.*?)\)/);
    if (match) {
      return match[1];
    }
    // If no parentheses, just return trimmed name
    return name.trim();
  }

  genarateSelectionNumber(data: any) {

    const KR8_mainNames = ["R1", "R2", "R3", "R4", "C1", "C2", "C3"];
    const KR8_shortNames = ["Low", "High", "Odd", "Even", "Red", "Black"];

    switch (data.countryCode) {
      case "KR8":

        // 1. If it belongs to the main names → return full name
        if (KR8_mainNames.includes(data.name)) {
          return data.name;
        }

        // 2. If it belongs to short-name list → return only first letter
        if (KR8_shortNames.includes(data.name)) {
          return data.name.charAt(0);   // returns L/H/O/E/R/B
        }

        // 3. Otherwise → fallback
        return data.selectionNumber;
      
      case "KR6":

        if(data.selectionNumber == "81"){
          return "H";
        }

        if(data.selectionNumber == "82"){
          return "T";
        }

        if(data.selectionNumber == "83"){
          return "E";
        }

        return data.selectionNumber;
      
      case "KR7":

        if(parseInt(data.selectionNumber) >= 25){

          if(data.name == "SOD Even"){
            return "E";
          }
          
          if(data.name == "SOD Odd"){
            return "O";
          }

          if(data.name == "SOD Over"){
            return "O";
          }

          if(data.name == "SOD Under"){
            return "U";
          }

          return data.name.split(' ').slice(1).join(' ');
        }

      default:
        // For all other game types
        return data.selectionNumber;
    }
  }

  isSpecialSelection(item): boolean {
    if(item.countryCode == "KR6"){
      return [81, 82, 83].includes(parseInt(item.selectionNumber));
    }

    if(item.countryCode == "KR7"){
      return parseInt(item.selectionNumber) >= 25;
    }
    
  }

  isGamesOption(betName): boolean {
    const games_cat = [
      "ROW 1", "ROW 2", "ROW 3", "ROW 4",
      "COLUMN 1", "COLUMN 2", "COLUMN 3",
      "LOW", "HIGH", "ODD", "EVEN",
      "RED", "BLACK", "NUMBERS", "HEADS", "EVENS", "TAILS",
      "FIRST BALL", "FIRST COLOR", "FIRST 2", "FIRST 3", "FIRST 4", "FIRST 5", "FIRST 6",
      "GREEN 0", "GREEN 2+", "GREEN 3+", "GREEN 4+", "GREEN 5+",
      "BLUE 0", "BLUE 2+", "BLUE 3+", "BLUE 4+", "BLUE 5+",
      "YELLOW 0", "YELLOW 2+", "YELLOW 3+", "YELLOW 4+", "YELLOW 5+",
      "RED 0", "RED 2+", "RED 3+", "RED 4+", "RED 5+",
      "SOD ODD", "SOD EVEN", "SOD OVER", "SOD UNDER"
    ];

    return games_cat.includes(betName);
  }

  hide_placeInputFunction(item: any): boolean {

    // reset all flags
    this.hide_placeInput = false;
    this.hide_winInput = false;

    if (!item) return false;

    switch (item.countryCode) {

      // ---------------------------------------------------
      // KR8 RULES
      // ---------------------------------------------------
      case "KR8": {
        const disabledNames = [
          "R1", "R2", "R3", "R4",
          "C1", "C2", "C3",
          "Low", "High",
          "Odd", "Even",
          "Red", "Black",
        ];

        if (disabledNames.includes(item.name)) {
          this.hide_placeInput = true;
          this.hide_winInput = true;
          // this.hide_placeInput_mOptions = true;
          return true;
        }
        return false;
      }

      // ---------------------------------------------------
      // KR6 (Keno) RULES
      // ---------------------------------------------------
      case "KR6": {
        const disabledNames = ["Heads", "Tails", "Evens"];

        const numberValue = Number(item.name);
        const isNumber = !isNaN(numberValue) && numberValue >= 1 && numberValue <= 80;

        if (disabledNames.includes(item.name) || isNumber) {
          return true;
        }

        return false;
      }

      // ---------------------------------------------------
      // KR7 (Lucky Loot) RULES
      // ---------------------------------------------------
      case "KR7": {
        // this.hide_placeInput_keno = true;
        // this.hide_placeInput_mOptions_keno = true;
        return true;
      }

      // ---------------------------------------------------
      // Default: OTHER COUNTRY CODES
      // ---------------------------------------------------
      default:
        return false;
    }
  }

  // hide_placeInputFunctionKeno(item: any): boolean {
  //   this.hide_placeInput_keno = false;
  //   this.hide_placeInput_mOptions_keno = false;

  //   if (!item) return false;
  //   const disabledNames = ["Heads", "Tails", "Evens"];
  //   const numberValue = Number(item.name);
  //   const isNumber = !isNaN(numberValue) && numberValue >= 1 && numberValue <= 80;

  //   // Disable ONLY for KR6 Keno
  //   if (item.countryCode === "KR6") {

  //     // Disable for Heads / Tails / Evens OR Numbers 1–80
  //     if (disabledNames.includes(item.name) || isNumber) {

  //       this.hide_placeInput_keno = true;
  //       this.hide_placeInput_mOptions_keno = true;

  //       return true; // hide place input
  //     }
  //   }
  //   return false; // show place input
  // }

  // hide_placeInputFunctionLuckyLoot(item: any): boolean {
  //   this.hide_placeInput_keno = false;
  //   this.hide_placeInput_mOptions_keno = false;

  //   if (!item) return false;
  //   if (item.countryCode === "KR7") {
  //     this.hide_placeInput_keno = true;
  //     this.hide_placeInput_mOptions_keno = true;
  //     return true;
  //   }

  //   return false;
  // }

  showMultipleOptions() {

    const list = this.selectionData.eventSelections;
    if (!list?.length) return;

    // NEW RULE → If ANY countryCode is NOT KR8 → return immediately
    const hasNonKR8 = list.some((x: any) => x.countryCode !== "KR8");
    if (hasNonKR8) {
      this.showMultipleOptions_double = true;
      this.showMultipleOptions_single = true;
      return;
    }

    this.showMultipleOptions_double = false;
    this.showMultipleOptions_single = false;

    const KR8_num = [
      "0 (Green)", "1 (Red)", "2 (Black)", "3 (Red)", "4 (Black)",
      "5 (Red)", "6 (Black)", "7 (Red)", "8 (Black)", "9 (Red)",
      "10 (Black)", "11 (Black)", "12 (Red)"
    ];

    const KR8_cat = [
      "R1", "R2", "R3", "R4",
      "C1", "C2", "C3",
      "Low", "High", "Odd", "Even",
      "Red", "Black"
    ];

    const names = list
      .filter((x: any) => x.countryCode === "KR8")
      .map((x: any) => x.name?.trim());

    let numCount = 0;
    let catCount = 0;

    names.forEach(n => {
      if (KR8_num.includes(n)) numCount++;
      if (KR8_cat.includes(n)) catCount++;
    });

    // -----------------------------
    // APPLY FINAL RULES
    // -----------------------------

    // CASE 1 → only numbers
    if (numCount >= 1 && catCount === 0) {
      this.showMultipleOptions_single = true;
      this.showMultipleOptions_double = true;
      return;
    }

    // CASE 2 → only categories
    if (catCount >= 1 && numCount === 0) {
      this.showMultipleOptions_single = true;
      this.showMultipleOptions_double = true;
      return;
    }

    // CASE 3 → 1 num + 1 cat
    if (numCount === 1 && catCount === 1) {
      this.showMultipleOptions_double = true;
      return;
    }

    // CASE 4 → 2 num + 1 cat
    // if (numCount === 2 && catCount === 1) {
    //   this.showMultipleOptions_double = true;
    //   return;
    // }

    // // CASE 5 → 1 num + 2 cat
    // if (numCount === 1 && catCount === 2) {
    //   this.showMultipleOptions_double = true;
    //   return;
    // }

    if (numCount > 1 && catCount >= 1) {
      this.showMultipleOptions_single = true;
      this.showMultipleOptions_double = true;
      return;
    }

    if (numCount == 1 && catCount >=1){
      this.showMultipleOptions_single = false;
      this.showMultipleOptions_double = true;
      return;
    }

    // Everything else stays false
  }
}
